import React, { useRef, useState, useEffect } from "react";
import Draggable from "react-draggable";
import { Dialog, Paper, DialogTitle, DialogContent, DialogActions } from "@mui/material";

const DraggablePaper = (props) => {
    const [bounds, setBounds] = useState({ left: 0, top: 0, right: 0, bottom: 0 });
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const dialogRef = useRef();
    const resizeObserver = useRef(null);

    const onStart = (_event, uiData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = dialogRef.current?.getBoundingClientRect();

        if (!targetRect) return;

        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    const checkAndMoveWithinBounds = () => {
        if (dialogRef.current) {
            const { clientWidth, clientHeight } = window.document.documentElement;
            const targetRect = dialogRef.current.getBoundingClientRect();
            let newX = position.x;
            let newY = position.y;

            if (targetRect.left < 0) newX -= targetRect.left;
            if (targetRect.right > clientWidth) newX -= targetRect.right - clientWidth;
            if (targetRect.top < 0) newY -= targetRect.top;
            if (targetRect.bottom > clientHeight) newY -= targetRect.bottom - clientHeight;

            if (newX !== position.x || newY !== position.y) {
                setPosition({ x: newX, y: newY });
            }
        }
    };

    useEffect(() => {
        const handleResize = () => {
            checkAndMoveWithinBounds();
        };

        resizeObserver.current = new ResizeObserver(handleResize);

        if (dialogRef.current) {
            resizeObserver.current.observe(dialogRef.current);
        }

        return () => {
            if (resizeObserver.current && dialogRef.current) {
                resizeObserver.current.unobserve(dialogRef.current);
            }
        };
    }, [position]);

    return (
        <Draggable
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
            bounds={bounds}
            position={position}
            onStart={onStart}
            onDrag={(e, data) => {
                setPosition((prev) => ({
                    x: prev.x + data.deltaX,
                    y: prev.y + data.deltaY,
                }));
            }}
        >
            <Paper {...props} ref={dialogRef} style={{pointerEvents: 'auto'}} />
        </Draggable>
    );
}

const DraggableEditModal = (props) => {
    const { open, title = '', onClose, children, ...other } = props;

    const handleClose = (event, reason) => {
        if (reason === 'backdropClick') {
            return;
        }
        onClose(event, reason);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={DraggablePaper}
            hideBackdrop={true}
            style={{ pointerEvents: 'none', zIndex: '1000' }}
            disableEnforceFocus
            {...other}
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <button onClick={onClose}>Close</button>
            </DialogActions>
        </Dialog>
    );
};

export default DraggableEditModal;
